import React from 'react'
import { Col, Grid, Icon } from 'gu-ui-kit'
import clsx from 'clsx'
import styles from 'modules/User/Security/Security.module.scss'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export const Status = ({ initialized, enabled }) => {
  const { t } = useTranslation()

  return initialized ? (
    enabled ? (
      <Grid
        className={clsx(
          styles['security__status'],
          styles['security__status_enabled'],
        )}
        alignItems={'center'}
        gap={8}
      >
        <Col>
          <Icon size={'m'} name={'shield-check'} />
        </Col>
        <Col>{t('user::security.2fa.status.enabled')}</Col>
      </Grid>
    ) : (
      <Grid
        className={clsx(
          styles['security__status'],
          styles['security__status_disabled'],
        )}
        alignItems={'center'}
        gap={8}
      >
        <Col>
          <Icon size={'m'} name={'shield-delete'} />
        </Col>
        <Col>{t('user::security.2fa.status.disabled')}</Col>
      </Grid>
    )
  ) : null
}

Status.propTypes = {
  initialized: PropTypes.bool,
  enabled: PropTypes.bool,
}
